import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './App.css'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import QuemSomos from './pages/QuemSomos'
import NossosProdutos from './pages/NossosProdutos'
import PontosDeVenda from './pages/PontosDeVenda'
import SejaRevendedor from './pages/SejaRevendedor'

function App() {
  return (
    <BrowserRouter>
      <div className="d-flex flex-column min-vh-100 bg-cf-black">
        <Navbar />
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/quem-somos" element={<QuemSomos />} />
            <Route path="/nossos-produtos" element={<NossosProdutos />} />
            <Route path="/pontos-de-venda" element={<PontosDeVenda />} />
            <Route path="/seja-revendedor" element={<SejaRevendedor />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  )
}

export default App
